module.exports = __webpack_public_path__ + "static/media/barbara3.469a3652.mp3";